export const saleTypes = [
  {id: "default", label: "Défaut"},
  {id: "clickAndCollect", label: "Click & Collect"},
  {id: "table", label: "À table"},
  {id: "delivery", label: "Livraison"},
  {id: "onSite", label: "Sur place"},
];

export const vatRates = [
  {value: 2.1, label: "FR - 2,10 %"},
  {value: 5.5, label: "FR - 5,50 %"},
  {value: 10, label: "FR - 10,00 %"},
  {value: 20, label: "FR - 20,00 %"},
];
